import { Component } from '@angular/core';
import { NavParams, NavController, ModalController } from 'ionic-angular';

import { MonitoramentoDecisoesService } from '../../../../providers/monitoramento-decisoes-service';
import { MenuService } from '../../../../providers/menu-service';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { ModulosController } from '../../modulos-controller';

import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";
import { ModalPreVisualizarMonitoramentoDecisoesPage } from '../../../modais/modal-pre-visualizacao/monitoramento-decisoes/modal-pv-monitoramento-decisoes';

@Component({
  selector: 'page-resumo-analise',
  templateUrl: 'resumo-analise.html',
  providers: [
    MonitoramentoDecisoesService
  ]
})
export class MonitoramentoDecisoesResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  loading: boolean = true;
  tituloPagina: string = "";
  isJurisdicionado: boolean;

  constructor(public navParams: NavParams,
    public navController: NavController,
    private monitoramentoDecisoesService: MonitoramentoDecisoesService,
    private menuService: MenuService,
    public gestaoPcaService: GestaoPcaService,
    public modalCtrl: ModalController,
    public alertService: AlertService,
    public usuarioService: UsuarioService) {

    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.carregarDados();

    this.setModuloId(10);
  }

  carregarDados() {

    this.isJurisdicionado = this.usuarioService.isJurisdicionado();

    this.tituloPagina = this.isJurisdicionado ? "Monitoramento de Decisões" : "Resumo das análises";

    this.monitoramentoDecisoesService.obterListaAnalises(this.monitoramentoDecisoesService.codigoModuloMonitoramentoDecisoes).subscribe(data => {
      this.listaAnalises = data;
      this.setIdModuloPca(this.listaAnalises[0].idModuloPca);
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  redirecionarParaAnalise(analise) {
    this.menuService.redirecionarSubPagina(this.monitoramentoDecisoesService.obterIdPaginaMonitoramentoDecisoes(), analise);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  previsualizarCertificado() {

    let modal = this.modalCtrl.create(ModalPreVisualizarMonitoramentoDecisoesPage, {});
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 10).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'MONITORAMENTO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'MONITORAMENTO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/monitoramento-decisoes/resumo-analise/resumo-analise.ts